import httpClient from "./httpClient";

export async function updateMe(body) {
  const { data } = await httpClient.patch("/users/me", body);
  return data.user;
}

export async function listSavings() {
  const { data } = await httpClient.get("/users/me/savings");
  return data.savings || [];
}

export async function createSaving(body) {
  const { data } = await httpClient.post("/users/me/savings", body);
  return data.saving;
}

export async function listMyComments() {
  const { data } = await httpClient.get("/users/me/comments");
  return data.comments || [];
}
